import styled from '@emotion/styled';
import { CONTENT_PRYMARY, CONTENT_PRYMARY_DARK } from 'constants/designSystem';
import React from 'react';

type Props = {
  title: string;
  value: number;
};

const BlockNumberItem = ({ title, value }: Props) => {
  return (
    <BlockHeight>
      <BlockHeightTitle>{title}</BlockHeightTitle>
      <BlockHeightNumber>#{value}</BlockHeightNumber>
    </BlockHeight>
  );
};

const BlockHeight = styled.div`
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #aaaaaa;
  line-height: 120%;
  min-width: 200px;
  box-sizing: border-box;
`;

const BlockHeightTitle = styled.p`
  font-size: 14px;
  color: #5b5b5b;
  margin-bottom: 6;
`;

const BlockHeightNumber = styled.p`
  font-size: 20px;
  color: ${CONTENT_PRYMARY_DARK};
  font-weight: 600;
`;

export default BlockNumberItem;
